import { render, staticRenderFns } from "./app.vue?vue&type=template&id=6715bdfc&"
import script from "./app.vue?vue&type=script&lang=js&"
export * from "./app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/reddeleon/Sites/watermark-designs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6715bdfc')) {
      api.createRecord('6715bdfc', component.options)
    } else {
      api.reload('6715bdfc', component.options)
    }
    module.hot.accept("./app.vue?vue&type=template&id=6715bdfc&", function () {
      api.rerender('6715bdfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/finishes-detail/app.vue"
export default component.exports